import { Navigate, useLocation } from 'react-router-dom';
import { useCurrentUser } from './useCurrentUser';
import HelperFunctions from '../helpers/HelperFunctions';

// Guard for the public sign-up entry (/sign-up).
//
// Trial CTAs all over the site point at /sign-up. Without this, a user who has
// already created an account but never paid lands back on the email/password
// card they've done before, instead of the payment step they actually need.
// Resolving that per link (useTrialCta) only fixes the links you remember to
// touch — doing it here means every /sign-up link, current and future, drops the
// user in the right place.
//
// - signed out                  -> the sign-up flow, as normal
// - signed up, no subscription  -> the plan step
// - signed up, has subscription -> nothing to buy; honour `redirectTo` if the
//                                  link carried one (locked content they were
//                                  trying to reach), else the dashboard
const SignUpRoute = ({ element: Component }) => {
    const [currentUser] = useCurrentUser();
    const { doesUserHaveSubscription } = HelperFunctions();
    const location = useLocation();

    if (!currentUser) return <Component />;

    if (doesUserHaveSubscription(currentUser.roles)) {
        return <Navigate to={location.state?.redirectTo || '/dashboard'} replace />;
    }

    return (
        <Navigate
            to="/sign-up/plan?plan=monthly"
            replace
            state={location.state}
        />
    );
};

export default SignUpRoute;
